export default __webpack_public_path__ + "static/media/logo-white.175e0214.png";